import { DatePicker, Row } from "antd";
import React, { memo, useEffect } from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const TmsDatePickerRange = ({
  className,
  label,
  to,
  from,
  setFrom,
  setTo,
  disabled,
  disabledDate,
}) => {
  const dateFormat = "DD/MM/YYYY";
  return (
    <Row justify="start" style={{ flexDirection: "column" }}>
      {label !== "" && (
        <div
          style={{
            marginBottom: label === "Select Batch Dates" ? "3px" : "5px",
            textAlign: "left",
          }}
        >
          {label}
        </div>
      )}

      <DatePicker.RangePicker
        className={className}
        defaultValue={[dayjs(from, dateFormat), dayjs(to, dateFormat)]}
        format={dateFormat}
        onChange={(e) => {
          if (e?.[0] && e?.[1]) {
            setFrom(dayjs(e[0]).format(`YYYY-MM-DD`));
            setTo(dayjs(e[1]).format(`YYYY-MM-DD`));
          } else {
            setFrom(undefined);
            setTo(undefined);
          }
        }}
        allowEmpty
        ranges={{
          Today: [dayjs(), dayjs()],
          "Last 7 Days": [dayjs().subtract(7, "days"), dayjs()],
          "Last 15 Days": [dayjs().subtract(15, "days"), dayjs()],
          // "This Month": [dayjs().startOf("month"), dayjs().endOf("month")],
        }}
        value={[dayjs(from), dayjs(to)]}
        disabled={disabled ?? false}
        allowClear={false}
        renderExtraFooter={() => {
          return disabledDate ? (
            <Row style={{ alignItems: "center" }}>
              <InfoCircleOutlined
                style={{ marginRight: "5px", color: "#888888" }}
              />{" "}
              <span style={{ color: "#888888" }}>
                Dates must be within the last 32 days.
              </span>
            </Row>
          ) : (
            ""
          );
        }}
      />
    </Row>
  );
};
export default memo(TmsDatePickerRange);
